import { Fragment, ReactElement } from 'react';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { IProps } from './types';
import * as S from './styles';

export function SliceContentPhotoPhoto({
  slice: { fields },
}: IProps): ReactElement {
  const count = fields.length;

  const renderContent = fields ? (
    <S.Wrapper className="slice-item content-photo-photo">
      {fields.map((item, i) => (
        <Fragment key={i}>
          {item.content_photo && (
            <S.Photo count={count}>
              {item.photo_link ? (
                <a href={item.photo_link} target="_blank" rel="noreferrer">
                  <PrismicNextImage
                    field={item.content_photo}
                    style={{ maxWidth: '100%', height: '100%' }}
                  />
                </a>
              ) : (
                <PrismicNextImage
                  field={item.content_photo}
                  style={{ maxWidth: '100%', height: '100%' }}
                />
              )}
            </S.Photo>
          )}
        </Fragment>
      ))}
    </S.Wrapper>
  ) : null;

  return renderContent;
}

SliceContentPhotoPhoto.componentName = 'content-photo-photo';
